<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><img alt="image" src="QuinsShangaiCircus.jpg"/></p>
<p class="caption"><i>Photo by Carol Martin</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 6into.vue?0a6a61df